export default __webpack_public_path__ + "static/media/regulatory--your-speed--g1.354c97cb.png";